import { styled, Box, Typography, TypographyProps } from '@mui/material';

export const StyledLabelTypography = styled(Typography)<TypographyProps>(
  () => ({
    width: '12em'
  })
);

export const StyledFormRow = styled(Box)(({ theme }) => ({
  display: 'flex',
  gap: theme.spacing(4),
  alignItems: 'center',
  flexWrap: 'wrap'
}));

export const StyledThresholdValueBox = styled(Box)(() => ({
  width: '12em',
  flexShrink: 0
}));

const withMuiFormControlGap = <
  C extends React.ComponentType<React.ComponentProps<C>>
>(
  component: C
) =>
  styled(component)(({ theme }) => ({
    '& .MuiFormControl-root': {
      gap: theme.spacing(1)
    }
  }));

export const StyledFormRowWithGap = withMuiFormControlGap(StyledFormRow);
export const StyledToggleGroupWrapper = withMuiFormControlGap(Box);
